var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.78125,
    width: 104.219,
    height: 104.219,
    rx: 9.8016,
    fill: "#F4FBEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_4804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.212 27.9442H73.373C75.007 27.9442 76.5741 28.5933 77.7295 29.7487C78.8849 30.9041 79.534 32.4712 79.534 34.1052V77.2323C79.534 78.8663 78.8849 80.4333 77.7295 81.5887C76.5741 82.7442 75.007 83.3933 73.373 83.3933H30.246C28.612 83.3933 27.0449 82.7442 25.8895 81.5887C24.7341 80.4333 24.085 78.8663 24.085 77.2323V34.1052C24.085 30.7167 26.8574 27.9442 30.246 27.9442H36.407V21.7832H42.568V27.9442H61.051V21.7832H67.212V27.9442ZM30.246 40.2662V77.2323H73.373V40.2662H30.246ZM48.729 55.6687V49.5077H54.89V55.6687H61.051V61.8297H54.89V67.9907H48.729V61.8297H42.568V55.6687H48.729Z",
    fill: "#53972C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_4804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.6101,
    height: 61.6101,
    fill: "white",
    transform: "translate(21.0039 21.7832)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.85f65031c862788285567133c57b1577.svg";
export { ForwardRef as ReactComponent };